import { render, staticRenderFns } from "./ConfiguracionInformacionApp.vue?vue&type=template&id=cc714538&"
import script from "./ConfiguracionInformacionApp.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionInformacionApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports